import { IBrickInstanceTargetingAction } from '../../../../../utility/IBrickInstanceTargetingAction';

export class CurrentNumberChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[Samwin CallControl] current number changed';

   constructor(public newNumber: string, public brickInstanceId: string) {}
}
